import styled, { css, type DefaultTheme } from 'styled-components';

import Colours from '/shared/styled/Colours';

import hiddenTextStyle from './__buttons__/hiddenTextStyle';

interface Props {
  theme: DefaultTheme;
  $secondary?: boolean;
  $inverted?: boolean;
  $inline?: boolean;
  $icon?: React.ReactNode | null;
  $iconAfter?: React.ReactNode | null;
  disabled?: boolean;
  $wideUnderline?: boolean;
  $leftAlignedTextWithIconAfter?: boolean;
  $hiddenText?: boolean;
}

function secondaryStyle({
  $secondary = false,
  $inverted = false,
  $inline = false,
  $icon = null,
  $iconAfter = null,
  disabled = false,
  $wideUnderline = false,
  theme,
}: Props) {
  if ($secondary) {
    return css`
      ${
        $inline
          ? css`
        display: inline;
        padding-bottom: 0.1em !important;
        border-bottom: 1px solid ${Colours.green};
      `
          : css`
        &::after {
          content: '';
          position: absolute;
          bottom: -0.3em;
          left: 0;
          width: 100%;
          border-bottom: 1px solid ${Colours.green};
        }
        ${
          $wideUnderline &&
          css`
          padding-bottom: 0.6em !important;
          margin-right: 0.3rem !important;

          &::after {
            bottom: 0;
          }
        `
        }
      `
      }
      ${
        Boolean($icon) &&
        css`
        padding-left: 0 !important;
      `
      }
      ${
        Boolean($iconAfter) &&
        css`
        padding-right: 0 !important;
      `
      }
      ${
        disabled &&
        css`
        color: ${Colours.greyLight6};

        &, &::after {
          border-bottom-color: ${Colours.greyLight6};
        }
      `
      }
      ${
        $inverted &&
        css`
        color: ${Colours.white};

        &, &::after {
          border-bottom-color: ${Colours.lime}
        }
      `
      }
    `;
  }
}

const leftAlignedTextWithIconAfter = ({ $leftAlignedTextWithIconAfter }: Props) => css`
  ${
    $leftAlignedTextWithIconAfter &&
    css`
    margin-right: 1.3333rem;
  `
  }
`;

export default styled.span<Props>`
  ${secondaryStyle}
  ${hiddenTextStyle}
  ${leftAlignedTextWithIconAfter}
`;
